import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const QUEST_ICON = { comment: "💬", like: "❤️", photo: "📸", post: "📝", invite: "🤝" };

export function useQuest(poll = 0) {
  const [q, setQ] = useState(null);
  useEffect(() => {
    const load = () => api.get("/quest").then(({ data }) => setQ(data)).catch(() => setQ(false));
    load();
    if (!poll) return undefined;
    const t = setInterval(load, poll);
    return () => clearInterval(t);
  }, [poll]);
  return [q, setQ];
}

export const endLabel = (end) => {
  const d = new Date(end);
  const same = d.toDateString() === new Date().toDateString();
  const t = d.toLocaleTimeString("de-DE", { timeZone: "Europe/Berlin", hour: "2-digit", minute: "2-digit" });
  return same ? `heute ${t} Uhr` : `${d.toLocaleDateString("de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "2-digit" })} ${t} Uhr`;
};

export function useLeft(end) {
  const [left, setLeft] = useState(() => new Date(end) - Date.now());
  useEffect(() => { const t = setInterval(() => setLeft(new Date(end) - Date.now()), 1000); return () => clearInterval(t); }, [end]);
  const s = Math.max(0, Math.floor(left / 1000));
  return { left, text: `${String(Math.floor(s / 3600)).padStart(2, "0")}:${String(Math.floor((s % 3600) / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}` };
}
